import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { SignIn } from "@clerk/react";

const Login = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Helmet>
        <title>Login | TLK Admin</title>
      </Helmet>
      <section className="beforeLoginSection clerkSignInOnly">
        <div className="beforeLoginRow">
          <SignIn
            forceRedirectUrl="/user/dashboard"
            fallbackRedirectUrl="/user/dashboard"
          />
        </div>
      </section>
    </>
  );
};

export default Login;
